var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      height: "100%"
    }
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("理赔流程")))]), _c("a-steps", {
    attrs: {
      direction: "vertical"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("a-step", {
      key: index,
      attrs: {
        status: _vm.step == index + 1 ? "process" : _vm.step <= index ? "wait" : "finish"
      }
    }, [_c("template", {
      slot: "title"
    }, [_c("div", {
      staticClass: "title-custom",
      attrs: {
        title: _vm.$t(item.name)
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")])]), _c("a-icon", {
      attrs: {
        slot: "icon",
        type: item.iconName
      },
      slot: "icon"
    })], 2);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };